package kz.dentalcrm.app.screens.employees

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.employees_load_error
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.data.network.response_model.employees.Employee
import kz.dentalcrm.app.domain.AppointmentRepository
import kz.dentalcrm.app.screens.employees.mvi.EmployeesSideEffect
import kz.dentalcrm.app.screens.employees.mvi.EmployeesState
import kz.dentalcrm.app.screens.employees.mvi.EmployeesViewEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class EmployeesViewModel :
    BaseStateViewModel<EmployeesViewEvent, EmployeesState, EmployeesSideEffect>() {

    private val appointmentRepository: AppointmentRepository by inject()

    override fun setInitialState() = EmployeesState()

    override fun handleEvents(event: EmployeesViewEvent) {
        when (event) {
            EmployeesViewEvent.LoadMoreEmployees -> {
                loadEmployees()
            }

            EmployeesViewEvent.Refresh -> {
                refresh()
            }

            else -> { }
        }
    }

    private var currentPage: Int = 1
    private var _isLastPage: Boolean = false
    private var employeeList = mutableListOf<Employee>()

    init {
        loadEmployees()
    }

    private fun refresh() {
        currentPage = 1
        _isLastPage = false
        employeeList.clear()
        setState { copy(employees = persistentListOf()) }
        loadEmployees()
    }

    private var fetchJob: kotlinx.coroutines.Job? = null

    private fun loadEmployees(
        search: String = ""
    ) {
        if (_isLastPage) {
            return
        }
        setState {
            copy(
                screenState = EmployeesState.ScreenState.Loading
            )
        }
        fetchJob?.cancel()
        fetchJob = launch(Dispatchers.Default) {
            val loadError = getString(Res.string.employees_load_error)
            appointmentRepository.getEmployees(
                page = currentPage,
                pageSize = PAGE_SIZE
            ).stateHandle(
                onSuccess = { data ->
                    employeeList.addAll(data?.data ?: emptyList())
                    currentPage++
                    setState {
                        copy(
                            employees = employeeList.toPersistentList(),
                            screenState = EmployeesState.ScreenState.Idle
                        )
                    }
                    _isLastPage = (data?.data?.size ?: 0) < PAGE_SIZE
                },
                onFailure = {
                    setState {
                        copy(
                            screenState = EmployeesState.ScreenState.Error(loadError)
                        )
                    }
                },
                onError = { _, _ ->
                    setState {
                        copy(
                            screenState = EmployeesState.ScreenState.Error(loadError)
                        )
                    }
                }
            )
        }
    }


    companion object {
        private const val PAGE_SIZE = 10
    }
}